// extracted by mini-css-extract-plugin
export default {"emojiContainer":"EmojiInput_emojiContainer__l9nsn","emojiPickerContainer":"EmojiInput_emojiPickerContainer__vWvlv"};